module.exports = __webpack_public_path__ + "static/media/hack_4_bg.6d7c90dd.jpg";